import { type AgeRange } from './AgeRangeReach';

export type Metadatas = {
  interpolated: boolean;
}

export type AgeRangeReachMetadataJsonAPI = {
  [age: AgeRange]: Metadatas;
}

export default class AgeRangeReachMetadata {
  range: AgeRange;
  interpolated: boolean;

  constructor(ageRange: AgeRange, interpolated: boolean) {
    this.range = ageRange;
    this.interpolated = interpolated;
  }

  static parse([age: AgeRange, metadatas: Metadatas]: any): AgeRangeReachMetadata {
    return new AgeRangeReachMetadata(age, metadatas.interpolated);
  }
}



// WEBPACK FOOTER //
// ./src/common/domain/AgeRangeReachMetadata.js